module.exports = __webpack_public_path__ + "img/Ocillobattant.aa2c4188.jpg";